document.addEventListener('DOMContentLoaded', function () {
    var loginModal = new HystModal({
        linkAttributeName: 'data-hystmodal',
        catchFocus: true,
        closeOnEsc: true,
        closeOnOverlay: true,
        closeOnButton: true,
        waitTransitions: true,
        beforeOpen: function () {
            jQuery(document).trigger('loginModal:beforeOpen');
        },
        afterClose: function () {
            jQuery(document).trigger('loginModal:afterClose');
        },
    });

    const loginForm = document.querySelector('#loginModal form');

    if (loginForm) {
        loginForm.addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
                event.preventDefault();
                this.submit();
                loginModal.close();
            }
        });
    }
});
